import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FragmentHeaderRoundTrip } from './types/FragmentHeaderRoundTrip';
import {
    getActiveProduct,
    getNonPrimeHotelRoom,
    getRooms,
    getSegments,
    isPrime,
} from '../../../../redux/currentSearch/selectors';
import { EntryPointProp, RoomsProps, SearchSegment } from '../../../../models';
import { HotelRoomUtils } from '../../../../utils';

export const RoomHeader = ({ segments, rooms, activeProduct, nonPrimeHotelRooms, isPrime }) => {
    let dynamicPax = 0;
    if (activeProduct=== 'hotels' && !isPrime) {
        dynamicPax = nonPrimeHotelRooms.adults + nonPrimeHotelRooms.kids.length;
    } else {
        dynamicPax = HotelRoomUtils.getTotalPax(rooms);
    }

    return <FragmentHeaderRoundTrip segments={segments} pax={dynamicPax} activeProduct={activeProduct} />;
};

RoomHeader.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment).isRequired,
    rooms: RoomsProps.isRequired,
    activeProduct: EntryPointProp.isRequired,
    nonPrimeHotelRooms: PropTypes.object.isRequired,
    isPrime: PropTypes.bool.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    rooms: getRooms,
    nonPrimeHotelRooms: getNonPrimeHotelRoom,
    activeProduct: getActiveProduct,
    isPrime: isPrime,
});

export const ConnectedRoomHeader = connect(mapStateToPropsSelector)(RoomHeader);
